// extracted by mini-css-extract-plugin
export default {"notice":"too-late-notice-styles__notice","time":"too-late-notice-styles__time"};